/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Show_Debug_Info_DescriptionInputs */

const fr_settings_show_debug_info_description = /** @type {(inputs: Settings_Show_Debug_Info_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les informations techniques de l'application.`)
};

const en_settings_show_debug_info_description = /** @type {(inputs: Settings_Show_Debug_Info_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show technical information about the application.`)
};

/**
* | output |
* | --- |
* | "Show technical information about the application." |
*
* @param {Settings_Show_Debug_Info_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_show_debug_info_description = /** @type {((inputs?: Settings_Show_Debug_Info_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Show_Debug_Info_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_show_debug_info_description(inputs)
	return en_settings_show_debug_info_description(inputs)
});